<!-- @format -->

<div class="hmf-checkbox-container">
	<label
		class="hmf-checkbox-label {{ CheckboxVariants[fontSize] }} hmf-pl-xxxs hmf-mb-0 hmf-body-m"
		for="hmfCheckbox"
		tabindex="0"
		[ngClass]="{
			error: isError && !isDisabled,
			disabled: isDisabled,
			'hmf-body-bold-m': isChecked
		}"
		(click)="isCheckboxSelectedState()"
		(keyup.enter)="isCheckboxSelectedState()">
		<input
			class="hmf-checkbox-input"
			type="checkbox"
			checked="isChecked"
			value=""
			id="hmfCheckbox"
			disabled="isDisabled" />
		<span
			class="hmf-checkbox-span"
			[ngClass]="isChecked && !isError && !isDisabled ? 'checkbox--active' : ''">
			<homefield-icon
				class="hmf-checkbox-svg"
				width="1em"
				height="1em"
				name="sign-check-fill"></homefield-icon>
		</span>
		{{ label }}
	</label>
	@if (errorMessage && isError && !isDisabled) {
		<p class="hmf-my-0 hmf-ml-m hmf-legal-s">
			{{ errorMessage }}
		</p>
	}
</div>
